module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Series preface")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("New Studies in Biblical Theology is a series of monographs that address key issues in the discipline of biblical theology. Contributions to the series focus on one or more of three areas: 1. the nature and status of biblical theology, including its relations with other disciplines (e.g. historical theology, exegesis, systematic theology, historical criticism, narrative theology); 2. the articulation and exposition of the structure of thought of a particular biblical writer or corpus; and 3. the delineation of a biblical theme across all or part of the biblical corpora.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Above all these monographs are creative attempts to help thinking Christians understand their Bibles better. The series aims simultaneously to instruct and to edify, to interact with the current literature, and to point the way ahead. In God’s universe, mind and heart should not be divorced: in this series we will try not to separate what God has joined together. While the footnotes interact with the best of the scholarly literature, the text is uncluttered with untransliterated Greek and Hebrew, and tries to avoid too much technical jargon. The volumes are written within the framework of confessional evangelicalism, but there is always an attempt at thoughtful engagement with the sweep of the relevant literature.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This volume, the second in the series, traces out a biblical theme that has been largely overlooked in this century. My colleague Dr Ray Ortlund has combined scholarly and pastoral gifts to examine afresh what it means to confess that Yahweh is the Bridegroom of his covenant people Israel, and that Christ is the Bridegroom of the church. Not only does the development of this theme link large swathes of the canon together, but it simultaneously discloses the profoundly personal nature of God’s covenanted love, exposes the odium of spiritual adultery (‘whoredom’), and, conversely, enriches our view of marriage.")])]), _vm._v(" "), _c('p', {
    staticClass: "sign"
  }, [_c('i', [_vm._v("D. A. Carson")]), _c('br'), _c('i', [_vm._v("Trinity Evangelical Divinity School,")]), _c('br'), _c('i', [_vm._v("Deerfield, Illinois")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3580722","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/pre2.vue
// module id = 66
// module chunks = 0